import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";

import {UiBaseComponent} from "../ui-base.component";

@Component({
    selector: 'qnect-ui-button-grp-single-select',
    templateUrl: './ui-button-grp-single-select.component.html',
    styleUrls: ['../ui-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UiButtonGrpSingleSelectComponent extends UiBaseComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
